import extend from "extend";

import AbstractStore from "../../Common/Stores/AbstractStore";
import { updateItem } from "../../Common/Utils";

function sortBySequence(a, b) {
    if (a.sequence < b.sequence) {
        return -1;
    }
    if (a.sequence > b.sequence) {
        return 1;
    }
    return 0;
}

export default class ProductStore extends AbstractStore {
    constructor(filters) {
        super(["load", "update"]);
        this.items = [];
        this.product = null;
        this.filters = {};
        Object.keys(filters).forEach(filter => (this.filters[filter] = null));
    }

    load(product, variants) {
        this.actions.load(product, variants);
    }

    update(product) {
        this.actions.update(product);
    }

    onLoad(product, variants) {
        this.items = [];
        this.items.push(product);
        this.setProduct(product);
        if (variants !== null) {
            Object.values(variants).forEach(variant => (this.items.push(variant)));
        }
        this.trigger(this.product, this.filters);
    }

    onUpdate(product) {
        this.product = product;
        updateItem(product, this.items);
        this.trigger(this.product, this.filters);
    }

    setProduct(product) {
        this.product = product;
        const properties = Object.keys(this.product.distinguishingProperties);
        if (properties.length > 0) {
            properties.forEach(property => (
                this.filters[property] = this.product.distinguishingProperties[property].value
            ));
        } else {
            Object.keys(this.filters).forEach((property) => {
                this.product.distinguishingProperties[property] = { name: property, value: null };
            });
        }
    }

    getFilteredValues(type) {
        const options = {};
        this.getFilteredResult(type)
            .map(product => product.distinguishingProperties[type])
            .sort(sortBySequence).map(property => property.value)
            .filter((value, index, self) => value !== null && self.indexOf(value) === index)
            .forEach((value) => { options[value] = value; });

        return options;
    }

    getValues(type) {
        const options = {};
        this.items
            .map(product => product.distinguishingProperties[type])
            .sort(sortBySequence)
            .map(property => property.value)
            .filter((value, index, self) => value !== null && self.indexOf(value) === index)
            .forEach((value) => { options[value] = value; });

        return options;
    }

    filter(key, value) {
        this.filters[key] = value === "" ? null : value;

        let products = this.getFilteredResult();
        if (products.length === 0) {
            const keys = Object.keys(this.filters);
            keys.forEach((filterKey) => {
                if (keys.indexOf(filterKey) > keys.indexOf(key)) {
                    this.filters[filterKey] = null;
                }
            });
        }

        const filters = extend(true, {}, this.filters);
        while (products.length === 0 && Object.keys(this.filters).length > 0) {
            const lastKey = Object.keys(this.filters).pop();
            delete this.filters[lastKey];
            products = this.getFilteredResult();
        }
        if (products.length === 1 && Object.keys(this.filters).length > 0) {
            this.setProduct(products.pop());
        } else {
            this.product = null;
            this.filters = filters;
        }
        this.trigger(this.product, this.filters);
    }

    getFilteredResult(ignore) {
        const filters = extend(true, {}, this.filters);
        if (typeof ignore !== "undefined") {
            const keys = Object.keys(filters);
            keys.forEach((filterKey) => {
                if (keys.indexOf(filterKey) > keys.indexOf(ignore)) {
                    delete filters[filterKey];
                }
            });
        }

        return this.items.filter(product => Object
                .keys(filters)
                .reduce(
                    (valid, key) => valid && product.distinguishingProperties[key].value === filters[key],
                    true,
                ));
    }
}

export function createProductStore(initialState) {
    const store = new ProductStore(initialState.filters);
    store.onLoad(initialState.product, initialState.variants);

    return store;
}



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductPurchase/Stores/ProductStore.jsx